import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteSlackInstallationMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;

export type DeleteSlackInstallationMutation = {
  __typename?: 'Mutation';
  deleteSlackInstallation: boolean;
};

export const DeleteSlackInstallationDocument = gql`
  mutation DeleteSlackInstallation($id: UUID!) {
    deleteSlackInstallation(id: $id)
  }
`;
export type DeleteSlackInstallationMutationFn = Apollo.MutationFunction<
  DeleteSlackInstallationMutation,
  DeleteSlackInstallationMutationVariables
>;

/**
 * __useDeleteSlackInstallationMutation__
 *
 * To run a mutation, you first call `useDeleteSlackInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSlackInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSlackInstallationMutation, { data, loading, error }] = useDeleteSlackInstallationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSlackInstallationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSlackInstallationMutation,
    DeleteSlackInstallationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSlackInstallationMutation,
    DeleteSlackInstallationMutationVariables
  >(DeleteSlackInstallationDocument, options);
}
export type DeleteSlackInstallationMutationHookResult = ReturnType<
  typeof useDeleteSlackInstallationMutation
>;
export type DeleteSlackInstallationMutationResult =
  Apollo.MutationResult<DeleteSlackInstallationMutation>;
export type DeleteSlackInstallationMutationOptions = Apollo.BaseMutationOptions<
  DeleteSlackInstallationMutation,
  DeleteSlackInstallationMutationVariables
>;
